import React from 'react';
import { useTranslation } from "react-i18next";
import { MyPanel, MyHead1, MyHead3 } from '../../component/ui/UI';

const updateHistroyData =
[
	{
		date: "2026/09/27",
		items: [
			{
				title: "アリーナ インポート・エクスポート",
				description: "実験的"
			},
			{
				title: "デッキ構築 デッキ情報",
				description: "列名接頭に'*'でカウントしない カード検討中用"
			}
		]
	},
	{
		date: "2026/05/22",
		items: [
			{
				title: "MTGJSON更新",
				description: "v5.3.0+20260521 TMT翻訳とか対応漏れある"
			}
		]
	},
	{
		date: "2026/02/24",
		items: [
			{
				title: "MTGJSON更新",
				description: "v5.3.0+20260223 setTranslations列名変更対応"
			},
			{
				title: "スマホ対応",
				description: "一通り機能使えるはず"
			}
		]
	},
	{
		date: "2026/02/08",
		items: [
			{
				title: "スマホ対応中",
				description: "まだデッキビルドが動かない"
			}
		]
	},
	{
		date: "2026/02/06",
		items: [
			{
				title: "デッキビルド改善",
				description: "カード追加で複数枚選べるようにする"
			}
		]
	},
	{
		date: "2026/01/28",
		items: [
			{
				title: "MTGJSON更新",
				description: "v5.2.2+20260126"
			}
		]
	},
	{
		date: "2026/01/14",
		items: [
			{
				title: "更新履歴作成",
				description: "フォーマット作成"
			},
			{
				title: "About作成",
				description: "このサイトについて と 参考にしたツール・サイト の作成"
			}
		]
	}
];

export const UpdateHistory = () =>
{
	const { t } = useTranslation();

	return (
		<div className="d-flex flex-column p-1 gap-1">
			<MyPanel>
				<MyHead1>
					更新履歴
				</MyHead1>
				<ul className="list-unstyled">
					{updateHistroyData.map((log, i) => (
						<li key={i} className="mb-3">
							<MyHead3>
								{log.date}
							</MyHead3>
							<ul className="mt-2 ps-3">
								{log.items.map((item, i) => (
									<li key={i} className="mb-2">
										{item.title}
										<div className="text-muted">
											{item.description}
										</div>
									</li>
								))}
							</ul>
						</li>
					))}
				</ul>
			</MyPanel>
		</div>
	);
};
